module.exports = __webpack_public_path__ + "h5/img/map.1a7c9178.png";